import React from 'react';
import { useWindowSize, sizes } from 'helpers/MediaHelper';

const ApplicationUIContext = React.createContext({});

function reducer(state, [action, payload]) {
  switch (action) {
    case 'SET_WINDOW_SIZE':
      return { ...state, windowSize: payload };
    default:
      return state;
  }
}

function ApplicationUIProvider({
  children,
  initialState = {
    windowSize: [window.innerWidth, window.innerHeight],
  },
}) {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const [windowWidth, windowHeight] = useWindowSize();

  React.useLayoutEffect(() => {
    dispatch(['SET_WINDOW_SIZE', [windowWidth, windowHeight]]);
  }, [windowWidth, windowHeight]);

  const value = { ...state, isMobile: state.windowSize[0] < sizes.mobile };

  return <ApplicationUIContext.Provider value={value}>{children}</ApplicationUIContext.Provider>;
}

export { ApplicationUIProvider, ApplicationUIContext };
